{
  "verified": "Geverifieerd",
  "iv_status": {
    "verified": "Geverifieerd",
    "pending": "In afwachting van",
    "attention": "Attentie"
  },
  "zoom_in": "Inzoomen",
  "zoom_out": "Uitzoomen",
  "rotate": "Draaien",
  "close": "Sluit",
  "esc_to_close": "Druk op ESC om te sluiten",
  "play": "Speel",
  "pause": "Pauze",
  "mute": "Stomme",
  "unmute": "Unmute",
  "enter_full_screen": "Volledig scherm openen",
  "exit_full_screen": "Volledig scherm afsluiten",
  "video_not_supported": "Uw browser ondersteunt de videotag niet.",
  "skip_forward": "Vooruit springen",
  "skip_backward": "Achteruit overslaan",
  "loading": "Laden",
  "loading_video": "Video aan het laden...",
  "loading_data_description": "Wacht even terwijl we je gegevens laden. Dit zal niet lang duren.",
  "no_results": "Geen resultaten",
  "nothing_found": "Niets gevonden",
  "save_changes": "Wijzigingen opslaan",
  "saved_exclamation": "Gered!",
  "saving": "Besparing",
  "validating": "valideren",
  "error": "Fout",
  "optional": "Optioneel",
  "search_property": "Eigendom zoeken",
  "reset_search": "Opnieuw zoeken",
  "no_items_to_show": "Geen items om te tonen",
  "showing_range_of_total_items": "Tonen van {{range}} van {{total}} items",
  "rows_per_page": "Rijen per pagina",
  "page_of_pages": "Pagina {{page}} van {{pages}}",
  "go_to_first_page": "Ga naar de eerste pagina",
  "go_to_previous_page": "Ga naar de vorige pagina",
  "go_to_next_page": "Ga naar de volgende pagina",
  "go_to_last_page": "Ga naar de laatste pagina",
  "sort_in_asc": "Sorteren in oplopende volgorde",
  "sort_in_desc": "Sorteren in aflopende volgorde",
  "sort_a_z": "Sorteer A → Z",
  "sort_z_a": "Sorteer Z → A",
  "clear_sorting": "Duidelijk sorteren",
  "reach_us_at_email": "Bereik ondersteuning op support@chekin.com",
  "please_wait": "Even geduld",
  "feature_coming_soon": "Binnenkort beschikbaar",
  "feature_coming_soon_description": "Deze functie is momenteel in ontwikkeling en zal binnenkort beschikbaar zijn. Blijf op de hoogte voor updates!",
  "download_all": "Alles downloaden",
  "entry_forms": "Inschrijfformulieren",
  "tutorial": "Les",
  "liveness_video": "Levendigheid video",
  "beta": "Bèta",
  "reviews": "Beoordelingen",
  "learn_more": "Meer informatie",
  "this_cannot_be_reverted": "Dit kan niet worden teruggedraaid",
  "delete": "Verwijder",
  "cancel": "Annuleren",
  "you_have_made_changes": "U hebt wijzigingen aangebracht",
  "would_you_like_to_save_them": "Wil je ze redden?",
  "save": "Sla",
  "dont_save": "Niet opslaan",
  "copied_exclamation": "Gekopieerd!",
  "search_placeholder": "Zoeken...",
  "type_to_search": "Type om te zoeken...",
  "loading_more": "Aan het laden...",
  "no_options": "Geen opties",
  "select_option": "Selecteer optie",
  "clear_all": "Alles wissen",
  "remove_item": "Verwijder {{label}}",
  "upload_file": "Bestand uploaden",
  "download_attachment": "Bijlage downloaden",
  "remove_file": "Bestand verwijderen",
  "open_calendar": "Open kalender",
  "clear_dates": "Duidelijke data",
  "select_dates": "Kies data",
  "pick_date_range": "Kies een datumbereik",
  "from": "Van",
  "to": "Naar",
  "pick_month": "Kies een maand",
  "pick_date": "Kies een datum",
  "month": "Maand",
  "day": "Dag",
  "year": "Jaar",
  "done": "Gedaan",
  "wrong_period_of_dates": "Geselecteerde periode is ongeldig",
  "date_range_max_days_error_one": "Het bereik kan niet groter zijn dan {{count}} dag",
  "date_range_max_days_error_other": "Het bereik kan niet groter zijn dan {{count}} dagen",
  "date_range_min_days_error_one": "Het bereik moet minstens {{count}} dag zijn",
  "date_range_min_days_error_other": "Het bereik moet minstens {{count}} dagen zijn",
  "past_dates": "Datum kan niet voor {{minDate}} liggen",
  "future_dates": "Datum kan niet na {{maxDate}} liggen",
  "signature_placeholder_text": "Teken in dit vak.<br/> Gebruik je vinger.<br/> Tik om te beginnen.",
  "open_devices_camera": "Open de camera van het apparaat",
  "place_document_inside_frame": "Plaats je document in het frame",
  "close_other_application_that_may_be_using_your_camera": "Sluit andere toepassingen die mogelijk gebruikmaken van uw camera",
  "if_you_use_external_camera_disconnect_and_reconnect": "Als u een externe camera gebruikt, koppelt u deze los en sluit u deze weer aan.",
  "close_the_browser_re_open_it": "Sluit de browser en open deze opnieuw",
  "camera_errors": {
    "experiencing_camera_issues": "Problemen met de camera?",
    "chekin_cant_use_your_camera": "Chekin kan je camera niet gebruiken",
    "please_try_a_different_browser": "Je camera werkt niet in deze browser. Probeer de link te openen in een andere browser.",
    "permissions_denied": "Toestemming geweigerd",
    "camera_permissions_denied": "De camera opent niet? Zorg ervoor dat de browser toestemming geeft om de camera te gebruiken.",
    "no_camera_device_found": "Geen camera gevonden. Sluit een camera aan.",
    "constraints_camera_error": "Aan beperkingen kan niet worden voldaan door beschikbare apparaten.",
    "safari_camera_error": "Safari kon niet voldoen aan de cameravereisten",
    "try_chrome_or_firefox": "Probeer Chrome of Firefox"
  },
  "clear": "Duidelijk",
  "show_less": "Minder tonen",
  "show_more": "Meer tonen",
  "tap_here_to_sign": "Tik hier om te ondertekenen",
  "click_here_to_sign": "Klik hier om te ondertekenen",
  "prefix": "Voorvoegsel",
  "prefix_required": "Voorvoegsel is vereist",
  "reset": "Reset",
  "show_password": "Wachtwoord tonen",
  "hide_password": "Wachtwoord verbergen",
  "increment": "Verhoging",
  "decrement": "Afname",
  "create_option": "Maak \"{{input}}\" aan.",
  "year_out_of_range": "Het jaar moet liggen tussen {{min}} en {{max}}",
  "clear_date": "Datum wissen",
  "select_date": "Selecteer datum",
  "draw_signature_here": "Zet hier je handtekening",
  "signature_hint": "Gebruik je muis of vinger",
  "clear_signature": "Duidelijke handtekening",
  "draw_signature_here_mobile": "Zet je handtekening",
  "signature_hint_mobile": "Gebruik je vinger",
  "camera_access_needed": "Toegang tot de camera vereist",
  "camera_access_needed_text": "Geef de camera toestemming om de foto te maken. Als dit wordt geblokkeerd, schakel dan de camera in via de instellingen van je browser en probeer het daarna opnieuw.",
  "dialog": "Dialoog"
}
